import { SeoPageType } from '@/constants';
import type { ILandingPage } from '@/interfaces';

export const extractCarrierSlug = (entry: ILandingPage, slug: string): string | undefined => {
  if (entry.seoPageType !== SeoPageType.carrier) return undefined;

  return slug.replace(/^track-/, '') || undefined;
};
